import moment from "moment";
import accounting from "accounting";
import { CURRENCY } from "./variables";

const _getOperativeCoverTables = (data) => {
    let filtered = data.quotePolicyOverview.filter(item => {
        return item.productId.toString() === data.productId.toString()
    });
    // hardcoded rule for Contract & Debt Recovery US 11905
    const contractAndDebQuestion = data.quote.applicationAnswersDtos.find(a => a.questionMachineName.toLowerCase() === 'contractanddebtrecovery');
    if(contractAndDebQuestion.optionMachineName?.toLowerCase() === 'no'){
        filtered = filtered.filter(item => {
            return item.quotePolicyBenefit.name.toString() !== "Contract & Debt Recovery"
        })
    }
    const operativeCoverCategories = filtered.map(item => item.quotePolicyBenefit.category).filter((v, i, a) => a.indexOf(v) === i)
    const tableBody =  operativeCoverCategories.map((item,index) => {

        const rows = filtered.filter(i => i.quotePolicyBenefit.category === item).map(i =>i.quotePolicyBenefit.name);
        let newRows = [];
        rows.map(r => {newRows.push([r]); return r});
        const calculateXposition = (index % 2) === 0 ? 45 : 310;
        const calculateYposition = index < 2 ? 270 : 440;
        return [
            {
                table: {
                    body: newRows
                },
                style: 'textLabel',
                layout: {
                    defaultBorder: false,
                },
                absolutePosition: {x: calculateXposition, y: calculateYposition}
            }
        ]
    });
    return tableBody
};

export function getQuoteSchedule (data) {
    const clientName = data._getQuestionAnswer('ClientName');
    const information =  data.covernote.body ? data.covernote.body : data.quoteScheduleInfo.body;
    const operativeCoverTables = _getOperativeCoverTables(data);
    return {
        pageSize: 'A4',
        pageMargins: [40, 70, 40, 60],
        footer: {
            columns: [
                {
                    stack: [
                        data.quoteScheduleMessage.map((row, index) => {
                            return {
                                margin: [20, 5, 20, 0],
                                text: [
                                    {
                                        text: row.body,
                                        fontSize: 8,
                                        alignment: 'center',
                                    }
                                ]
                            }
                        })
                    ],
                }
            ],
        },
        header:  {
            margin: [20, 20, 0, 10],
            columns: [
                {
                    stack: [
                        {
                            text: data.quoteTitle + ' Business Legal',
                            fontSize: 14,
                            style: 'bold',
                            layout: {
                                defaultBorder: false
                            }
                        },
                        ' ',
                        {
                            width: '*',
                            table: {
                                widths: ["50%","50%"],
                                body: [
                                    [
                                        'Quotation reference: ' + data.quote.aragReference,
                                        'Date: ' +  moment().format("DD/MM/YYYY hh:mm:ss")

                                    ],
                                ]
                            },
                            style: 'textLabel',
                            layout: {
                                defaultBorder: false
                            }
                        },
                    ],
                    width: '*',
                },
                {
                    margin: [0,-10,10,10],
                    alignment: 'right',
                    image: 'data:image/png;base64,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',
                    width: 50,
                },
            ],
        },
        background: function () {
            return {
                canvas: [
                    {
                        type: 'rect',
                        x: 0, y: 0, w: 595.28, h: 80.89,
                        color: '#ffd102'
                    },
                    {
                        type: 'rect',
                        x: 0, y: 761, w: 595.28, h: 80.89,
                        color: '#ffd102'
                    }
                ]
            };
        },
        content: [
            {
                canvas: [
                    {
                        type: 'rect',
                        x: 0,
                        y: 30,
                        w: 255,
                        h: 110,
                        r: 5,
                        lineColor: 'black',
                        color: '#CCCCCC',
                    },
                    {
                        type: 'rect',
                        x: 265,
                        y: 30,
                        w: 255,
                        h: 110,
                        r: 5,
                        lineColor: 'black',
                        color: '#CCCCCC',
                    },
                ]
            },
            //Agent - Insured
            {
                columns: [
                    {
                        width: '*',
                        marginRight: 5,
                        stack: [
                            {
                                table: {
                                    widths: ["50%", "50%"],
                                    body: [
                                        [
                                            {
                                                bold: true,
                                                colSpan: 2,
                                                marginLeft: 5,
                                                text: 'Insured:',
                                                style: 'textLabelStrong',
                                            }
                                        ],
                                        [
                                            {
                                                colSpan: 2,
                                                marginLeft: 5,
                                                text: clientName,
                                                style: 'textLabel'
                                            }
                                        ],
                                        [
                                            {
                                                colSpan: 2,
                                                marginLeft: 5,
                                                text: data.quote.clientAddress?data.quote.clientAddress:' ',
                                                style: 'textLabel'
                                            }
                                        ],
                                        [
                                            {
                                                colSpan: 2,
                                                text: ' ',
                                                style: 'textLabel'
                                            }
                                        ],
                                        [
                                            {
                                                colSpan: 2,
                                                text: ' ',
                                                style: 'textLabel'
                                            }
                                        ],
                                        [
                                            {
                                                colSpan: 2,
                                                text: ' ',
                                                style: 'textLabel'
                                            }
                                        ]
                                    ]
                                },
                                layout: {
                                    defaultBorder: false,
                                    paddingLeft: function (i, node) {
                                        return 0;
                                    },
                                    paddingTop: function (i, node) {
                                        return 5;
                                    },
                                    paddingBottom: function (i, node) {
                                        return 0;
                                    },
                                },
                                absolutePosition: {x: 45, y: 100}
                            }
                        ]
                    },
                    //Agent
                    {
                        width: '*',
                        // paddingLeft: 5,
                        stack: [
                            {
                                table: {
                                    widths: ["50%", "50%"],
                                    body: [
                                        [
                                            {
                                                colSpan: 2,
                                                text: 'Agent:',
                                                style: 'textLabelStrong',
                                                marginLeft: 10,
                                            }

                                        ],
                                        [
                                            {
                                                colSpan: 2,
                                                text: data.broker.lawsysName.replace(/\(ID:\s\d*\)$/g, ''),
                                                marginLeft: 10,
                                                style: 'textLabel'
                                            }
                                        ],
                                        [
                                            {
                                                colSpan: 2,
                                                text: data.broker.addressLine1,
                                                marginLeft: 10,
                                                style: 'textLabel'
                                            }
                                        ],
                                        [
                                            {
                                                colSpan: 2,
                                                text: data.broker.postCode,
                                                marginLeft: 10,
                                                style: 'textLabel'
                                            }
                                        ]
                                    ]
                                },
                                layout: {
                                    defaultBorder: false,
                                    paddingLeft: function (i, node) {
                                        return 0;
                                    },
                                    paddingTop: function (i, node) {
                                        return 5;
                                    },
                                    paddingBottom: function (i, node) {
                                        return 0;
                                    },
                                },
                                absolutePosition: {x: 305, y: 100}
                            }
                        ]
                    }
                ],
            },
            //Quote questions
            {
                columns: [
                    {
                        width: '*',
                        stack: [
                            {
                                table: {
                                    widths: ['20%', '80%'],
                                    body: [
                                        ...data.quoteQuestions.filter(question => {
                                            return data._getQuestionAnswer(question.machineName);
                                        }).filter(q => q.machineName === "BusinessDescription" || q.machineName === "AnnualWageroll").map((question, index) => {
                                            const answer = data._getQuestionAnswer(question.machineName);
                                            return (
                                              [
                                                  {
                                                      border: [false, false, false, false],
                                                      text: question.name + ':',
                                                      style: 'textLabel'
                                                  },
                                                  {
                                                      marginLeft: 15,
                                                      alignment: 'left',
                                                      border: [false, false, false, false],
                                                      text:  question.inputType ===  'amount'?
                                                        accounting.formatMoney(answer , `${CURRENCY} `, 2)
                                                        :
                                                        answer,
                                                      style: 'textLabel'
                                                  }
                                              ]
                                            )
                                        })
                                    ]
                                },
                                layout: {
                                    defaultBorder: true,
                                    paddingLeft: function (i, node) {
                                        return 0;
                                    },
                                    paddingTop: function (i, node) {
                                        return 5;
                                    },
                                    paddingBottom: function (i, node) {
                                        return 0;
                                    },
                                    hLineWidth: function(i, node) {
                                        return 0.25;
                                    },
                                    vLineWidth: function(i, node) {
                                        return 0;
                                    },
                                }
                            }
                        ]
                    }
                ]
            },
            //Operative covers
            {
                marginTop: 10,
                text:'Operative covers:',
                style: 'textLabelStrong',
            },
            // canvas for 1st row of covers
            {
                canvas: [
                    {
                        type: 'rect',
                        x: 0,
                        y: 5,
                        w: 255,
                        h: 160,
                        r: 5,
                        lineColor: 'black',
                    },
                    {
                        type: 'rect',
                        x: 265,
                        y: 5,
                        w: 255,
                        h: 160,
                        r: 5,
                        lineColor: 'black',
                    },
                ]
            },
            //canvas for second row of covers
            {
                canvas: [
                    {
                        type: 'rect',
                        x: 0,
                        y: 10,
                        w: 255,
                        h: 60,
                        r: 5,
                        lineColor: 'black',
                    },
                    {
                        type: 'rect',
                        x: 265,
                        y: 10,
                        w: 255,
                        h: 60,
                        r: 5,
                        lineColor: 'black',
                    },
                ]
            },
            //operative covers
            {
                columns: [
                    {
                        width: '*',
                        stack: [
                            {
                                table: {
                                    widths: ['50%', '50%'],
                                    body: operativeCoverTables
                                },
                                layout: {
                                    defaultBorder: false,
                                }
                            }
                        ]
                    }
                ]
            },
            //on line Legal Services
            //link
            {
                text: [
                    {
                        text: 'ARAG on-line Legal Services: ',
                        style: 'textLabel'
                    },
                    {
                        text: 'www.arag.co.uk/docs',
                        link: 'https://www.arag.co.uk/docs',
                        style: 'textLink'
                    },
                    {
                        text: ' Voucher Code: ',
                        style: 'textLabel'
                    },
                    {
                        text: 'To be confirmed',
                        style: 'textLabel'
                    }
                ]
            },
            // Cost of cover...
            {
                canvas: [
                    {
                        type: 'rect',
                        x: 0,
                        y: 10,
                        w: 520,
                        h: 40,
                        r: 5,
                        lineColor: 'black',
                        color: '#CCCCCC',
                    },
                ]
            },
            {
                id: 'scheduleTable',
                table: {
                    widths: ["33%","33%","34%"],
                    body: [
                        [
                            {
                                text: 'Cost of cover: ',
                                style: ['textLabelStrong'],
                                colSpan: 3
                            },{},{}
                        ],
                        [
                            {
                                text: 'Premium: ' + accounting.formatMoney(data.productInfo.premium, `${CURRENCY} `, 2),
                                style: ['textLabel']
                            },
                            {
                                text: 'IPT at '+ data.quoteIPT.taxPercentage+'%: ' + accounting.formatMoney((data.quoteIPT.taxPercentage /100) * data.productInfo.premium, `${CURRENCY} `, 2),
                                style: ['textLabel']
                            },
                            {
                                text: 'Total Premium ' + accounting.formatMoney(data.totalPremium, `${CURRENCY} `, 2),
                                style: ['textLabel']
                            }]
                    ]
                },
                layout: {
                    defaultBorder: false,
                },
                absolutePosition: {x: 45, y: 540}
            },
            //LOI
            {
                columns: [
                    {
                        width: '*',
                        stack: [
                            {
                                table: {
                                    widths: ['20%', '80%'],
                                    body: [
                                        [
                                            {
                                                border: [false, false, false, false],
                                                text: 'Limit of Indemnity: ',
                                                style: 'textLabel'
                                            },
                                            {
                                                marginLeft: 15,
                                                alignment: 'left',
                                                border: [false, false, false, false],
                                                text: (data.limitOfIndemnity?
                                                  accounting.formatMoney(
                                                    data.limitOfIndemnity, `${CURRENCY} `, 2
                                                  ):'') + ` per claim (${CURRENCY} 25,000 for Crisis Communication)`,
                                                style: 'textLabel'
                                            }
                                        ],
                                        [
                                            {
                                                border: [false, false, false, false],
                                                text: 'Aggregate Limit: ',
                                                style: 'textLabel'
                                            },
                                            {
                                                marginLeft: 15,
                                                alignment: 'left',
                                                border: [false, false, false, false],
                                                text: (accounting.formatMoney(data.quoteAdditionalInfo.aggregateLimit, `${CURRENCY} `, 2)) + ' per annum (Employment Compensation Awards)',
                                                style: 'textLabel'
                                            }
                                        ]
                                    ]
                                },
                                layout: {
                                    defaultBorder: true,
                                    paddingLeft: function (i, node) {
                                        return 0;
                                    },
                                    paddingTop: function (i, node) {
                                        return 5;
                                    },
                                    paddingBottom: function (i, node) {
                                        return 0;
                                    },
                                    hLineWidth: function(i, node) {
                                        return 0.25;
                                    },
                                    vLineWidth: function(i, node) {
                                        return 0;
                                    },
                                }
                            }
                        ]
                    }
                ]
            },
            //notes - endorsements etc
            {
                canvas: [
                    {
                        type: 'rect',
                        x: 0,
                        y: 10,
                        w: 520,
                        h: 60,
                        r: 5,
                        lineColor: 'black',
                        color: '#CCCCCC',
                    },
                ]
            },
            {
                canvas: [
                    {
                        type: 'rect',
                        x: 0,
                        y: 10,
                        w: 520,
                        h: 50,
                        r: 5,
                        lineColor: 'black',
                        color: '#CCCCCC',
                    },
                ]
            },
            {
                stack: [
                    {
                        id: 'notes',
                        stack: [
                            {
                                style: {
                                    color: 'black',
                                    fontSize: 9,
                                },
                                table: {
                                    widths: ['*'],
                                    body: [
                                        [{
                                            text: [{
                                                text: "Further information: \r\n",
                                                bold: true
                                            }, {
                                                text: information
                                            }
                                            ]
                                        }]
                                    ]
                                },
                                layout: {
                                    defaultBorder: false,
                                    padding: function (i, node) {
                                        return 5;
                                    },
                                },
                                absolutePosition: {x: 45, y: 625}
                            },
                        ]
                    },
                    {
                        id: 'endorsements',
                        margin: [0,5,0,0],
                        stack: [
                            {
                                style: {
                                    color: 'black',
                                    fontSize: 9,
                                },
                                table: {
                                    widths: ['*'],
                                    body: [
                                        [{
                                            text: [{
                                                text: 'Endorsements: ',
                                                bold: true
                                            }, {
                                                text: (data.quoteAdditionalInfo && data.quoteAdditionalInfo.endorsements ? data.quoteAdditionalInfo.endorsements : '')
                                            }]
                                        }
                                        ]
                                    ]
                                },
                                layout: {
                                    defaultBorder: false,
                                    padding: function (i, node) {
                                        return 5;
                                    },
                                },
                                absolutePosition: {x: 45, y: 695}
                            },
                        ]
                    },
                ]
            },
        ],
        styles: {
            greyBackground: {
                fillColor: '#CCCCCC',
            },
            yellowBackground: {
                fillColor: '#ffd102',
            },
            iptRow: {
                color: 'white',
                fillColor: 'black',
            },
            textLabelStrong: {
                fontSize: 9,
                bold: true
            },
            textLabel: {
                fontSize: 9
            },
            textLink: {
                fontSize: 9,
                decoration: 'underline',
                color: 'blue'
            },
            bold: {
                bold: true
            },
            header: {
                fillColor: '#ffd102',
                backgroundColor: '#ffd102',
            },
            footer: {
                fillColor: '#ffd102',
                backgroundColor: '#ffd102',
                background: '#ffd102',
            },
            headerTitle: {
                fontSize: 12
            },
            lineOutOfLimits: {
                margin: [-50, 0, -100, 0],
                color: 'white',
                fontSize: 1
            },
            defaultStyle: {
                // alignment: 'justify'
            }
        }
    }
};
